<template>
  <div>
    <a v-if="!!settings.show_video" href="" @click.prevent class="news-heading" style="cursor: default">
      <div class="news-video">
        <video :src="newsVideo" poster="/assets/images/teaser_preview.png" loop muted playsinline autoplay></video>
      </div>
    </a>

    <div class="news-container news-container--rounded">
      <div class="wrapper">
        <div class="news-list__headline hidden-xs">
          <h5>{{ settings.title || trans.text.news.latestNewsLabel }}</h5>
        </div>
        <div class="news-list news-list--col3">
          <div class="news-card__col" v-for="n in otherNews"
               v-if="!!allNews && allNews.hasOwnProperty('en') && n.active">
            <a :href="getNewsLink(n)" class="news-card__item" tag="a">
              <div class="news-card__image">
                <img :src="getPostImage(n)" alt="" v-if="n.images[0]"/>
              </div>
              <div class="news-card__text">
                <h4>{{ getNewsTitle(n) }}</h4>
                <p>{{ getNewsDescription(n) }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  props: ['lang', 'trans', 'settings'],
  computed: {
    ...mapGetters(['allNews', 'storage']),
    newsVideo() {
      if (!!this.settings.show_video) {
        if (!!this.settings?.header_video?.url) {
          return this.settings.header_video.url
        }
        return `${this.storage}assets/video/teaser.mp4`
      }

      return ""
    },
    language() {
      return this.lang;
    },
    news() {
      if (!!this.allNews) {
        let language = this.lang;
        return this.allNews[language];
      }
      return [];
    },
    otherNews() {
      if (!!this.allNews && this.allNews.hasOwnProperty('en')) {
        let language = this.lang;
        return this.allNews[language];
      }
      return [];
    },
    headerNewsStyle() {
      let language = this.lang;
      if (!!this.allNews && this.allNews.hasOwnProperty(language)) {
        return this.getStorageLink(this.news[0].images[0].header_image)
      }
      return null;
    }
  },
  methods: {
    ...mapActions(['getNews']),
    getStorageLink(path) {
      return this.storage + path;
    },
    getPostImage(post) {
      if (post.images.length > 0) {
        return this.getStorageLink(post.images[0].image);
      }
      return '';
    },
    getNewsTitle(news) {
      let prefix;
      let language = this.lang;
      prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }
      if (!!news && !!news[`${prefix}title`]) {
        return news[`${prefix}title`]
      }
      return news[`title`]
    },
    getNewsDescription(news) {
      let prefix;
      let language = this.lang;
      prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }
      if (!!news && !!news[`${prefix}desc`]) {
        return this.stripHtml(news[`${prefix}desc`])
      }
      return this.stripHtml(news[`desc`])
    },
    stripHtml(html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    getNewsLink(post) {
      if (post.slug) {
        return `/${this.lang}/post/${post.slug}`
      } else {
        return '';
      }
    },
  },
  mounted() {
    this.getNews({
      path: this.$path,
      limit: this.settings.latest_news || 15
    })
  }
}
</script>

<style scoped lang="scss">
.news-container {
  margin-top: 54px;
}

.news-heading + .news-container {
  margin-top: 100vh;
}
</style>
